import React from "react";
import {
  TabbedForm,
  FormTab,
  EditController,
  EditView,
  SelectInput,
  BooleanInput,
  SaveButton,
  Toolbar,
  DeleteButton,
  TextField,
  TextInput,
  required
} from "react-admin";
import FootballFormTab from "./FootballFormTab";
import GirlsVolleyballFormTab from "./GirlsVolleyballFormTab";
import BasketballFormTab from "./BasketballFormTab";
import SoccerFormTab from "./SoccerFormTab";
import BaseballFormTab from "./BaseballFormTab";

const GameStatsEdit = (props) => {
  const CustomToolbar = function (props) {
    const redirectPath = `/gamestats/${props.record.id}/show`;
    // note: delete redirect is non-optimal, fixing it 'correctly'
    // requires tracking where the user navigated in from, which we do
    // some places, but in this case it's not worth it, so just go
    // back to seasonTeams...
    return (
      <Toolbar {...props}>
        <SaveButton redirect={redirectPath} />
        <DeleteButton undoable={false} redirect="/seasonTeams" />
      </Toolbar>
    );
  };
  return (
    <EditController undoable={false} {...props}>
      {(controllerProps) => (
        <EditView undoable={false} {...props} {...controllerProps}>
          <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="summary">
              <TextField source="id" />
              <TextField source="sportCode" />
              <TextField source="seasonCode" />
              <SelectInput
                source="gameStatus"
                choices={[
                  { id: "PRELIMINARY", name: "PRELIMINARY" },
                  { id: "SCHEDULED", name: "SCHEDULED" },
                  { id: "LIVE", name: "LIVE" },
                  { id: "HALFTIME", name: "HALFTIME" },
                  { id: "CANCELLED", name: "CANCELLED" },
                  { id: "FORFEIT", name: "FORFEIT" },
                  { id: "WEATHER_DELAY", name: "WEATHER_DELAY" },
                  { id: "FINAL", name: "FINAL" }
                ]}
              />
              <TextInput source="gameDateString" validate={[required()]} />
              <TextInput source="gameTimeString" />
              <BooleanInput source="gameIsDistrict" />
              <SelectInput
                source="playoffRound"
                allowEmpty={true}
                choices={[
                  { id: "BI_DISTRICT", name: "Bi-District" },
                  { id: "AREA", name: "Area" },
                  { id: "REGIONAL_QUARTERFINAL", name: "Regional Quaterfinal" },
                  { id: "REGIONAL_SEMIFINAL", name: "Regional Semifinal" },
                  { id: "REGIONAL_FINAL", name: "Regional Final" },
                  { id: "STATE_SEMIFINAL", name: "State Semifinal" },
                  { id: "STATE_FINAL", name: "State Final" }
                ]}
              />
              <TextInput source="homeTeamCode" />
              <TextInput source="awayTeamCode" />
              <TextInput fullWidth={true} multiline source="gameStory" />
              <BooleanInput source="gameStoryIsPublished" />
              <TextInput fullWidth={true} multiline source="internalNotes" />
            </FormTab>
            <FormTab label="home stats">
              {controllerProps.record &&
                controllerProps.record.sportCode === "football" && (
                  <FootballFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-volleyball" && (
                  <GirlsVolleyballFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-basketball" && (
                  <BasketballFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-basketball" && (
                  <BasketballFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-soccer" && (
                  <SoccerFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-soccer" && (
                  <SoccerFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "softball" && (
                  <BaseballFormTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "baseball" && (
                  <BaseballFormTab side="home" {...props} />
                )}
            </FormTab>
            <FormTab label="away stats">
              {controllerProps.record &&
                controllerProps.record.sportCode === "football" && (
                  <FootballFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-volleyball" && (
                  <GirlsVolleyballFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-basketball" && (
                  <BasketballFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-basketball" && (
                  <BasketballFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-soccer" && (
                  <SoccerFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-soccer" && (
                  <SoccerFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "softball" && (
                  <BaseballFormTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "baseball" && (
                  <BaseballFormTab side="away" {...props} />
                )}
            </FormTab>
          </TabbedForm>
        </EditView>
      )}
    </EditController>
  );
};

export default GameStatsEdit;
